import React from 'react'
import Avatar from '../../../Assets/Image/avatar.png'
import { useParams } from 'react-router-dom'

const LeftView = ({ company }) => {
  const { companyid } = useParams();
  return (
    <div>
      <div className="TopDetails">
        <div className="Avatar">
          <img src={company?.logo_url?company?.logo_url:Avatar} alt='display pic' />
        </div>
        <h4 className="CompanyNameLabel">{company?.name} </h4>
        <p className="CompanyName">{company?.email} </p>
      </div>
      <ul className="Bottom_Details">
        <li className="Box">
          <h4 className="Detail_label">Account ID</h4>
          <p className="Detail_value">ID-454534{`${companyid}`}</p>
        </li>
        <li className="Box">
          <h4 className="Detail_label">Company Email</h4>
          <p className="Detail_value">{company?.email} </p>
        </li>
        <li className="Box">
          <h4 className="Detail_label">Company Address</h4>
          <p className="Detail_value">{company?.location} </p>
        </li>
        {/* <li className="Box">
          <h4 className="Detail_label">Last Login</h4>
          <p className="Detail_value">April 25 2023</p>
        </li> */}
        <li className="Box">
          <h4 className="Detail_label">Language</h4>
          <p className="Detail_value">English</p>
        </li>
      </ul>
    </div>
  )
}

export default LeftView